import React, {
    createContext,
    useContext,
    useState,
    useEffect,
} from 'react';

import api, { setToken as apiSetToken, clearToken } from '../services/api';
import { jwtDecode } from 'jwt-decode';

const AuthContext = createContext();

function setTokenLocalStorage(token) {
    localStorage.setItem('accessToken', token);
    apiSetToken(token);
}

const AuthProvider = ({ children }) => {
    const [isAuthenticated, setIsAuthenticated] = useState(false);
    const [authReady, setAuthReady] = useState(false);
    const [user, setUser] = useState(null);

    useEffect(() => {
        const initStorageToken = async () => {
            const token = localStorage.getItem('accessToken');
            const refreshToken = localStorage.getItem('refreshToken');

            if (!token || !refreshToken) {
                setAuthReady(true);
                return;
            }

            apiSetToken(token);

            try {
                const response = await api.post('/refreshToken', { refreshToken });

                if (response.data?.auth) {
                    const newToken = response.data.token;
                    setTokenLocalStorage(newToken);

                    const payload = jwtDecode(newToken);
                    setUser(payload);
                    setIsAuthenticated(true);
                } else {
                    logout();
                }
            } catch (e) {
                logout();
            } finally {
                setAuthReady(true);
            }
        };

        initStorageToken();
    }, []);

    async function login(email, senha) {
        try {
            const response = await api.post('/get-token', { email, senha }, {
                skipAuthRefresh: true
            });

            const { token, refreshToken, auth } = response.data;

            if (!auth || !token || !refreshToken) {
                return { success: false, message: 'Credenciais inválidas.' };
            }

            localStorage.setItem('accessToken', token);
            localStorage.setItem('refreshToken', refreshToken);
            api.defaults.headers.common['Authorization'] = `Bearer ${token}`;

            const payload = jwtDecode(token);
            setUser(payload);
            setIsAuthenticated(true);

            return { success: true };
        } catch (error) {
            return {
                success: false,
                message:
                    error.response?.data?.message || 'Erro ao tentar login. Verifique seus dados.',
            };
        }
    }


    function logout() {
        clearToken();
        setIsAuthenticated(false);
        setUser(null);
        setAuthReady(true);
    }

    return (
        <AuthContext.Provider
            value={{
                login,
                logout,
                isAuthenticated,
                authReady,
                user,
            }}
        >
            {children}
        </AuthContext.Provider>
    );
};

const useAuthContext = () => useContext(AuthContext);

export { AuthProvider, useAuthContext };
